export const isCanPrintOnMobile = (booking, selectedItemRefs) => {
  const isABSOrADS = booking.outbound.concat(booking.inbound).some((leg) => !!leg?.addOnLeg);
  let isIndirect = false;

  if (selectedItemRefs && selectedItemRefs.length > 0) {
    isIndirect = booking.allBookingItems
      .filter(({ itemRef }) => selectedItemRefs.includes(itemRef))
      .some(({ associatedItemRefs = [] }) => associatedItemRefs.some((ref) => selectedItemRefs.includes(ref)));
  } else {
    isIndirect = !(booking.outbound.length < 2) || !(booking.inbound.length < 2);
  }

  return !isABSOrADS && !isIndirect;
};
